



























































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import moment from "moment";
import filesaver from "file-saver";
import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "finance/getTradeLogs";

  paychannels: any[] = [];

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", scopedSlots: { customRender: "username" } },

    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "支付金额（元）", scopedSlots: { customRender: "fee" } },
    { title: "支付时间", dataIndex: "created_time" },
    { title: "付款方式", dataIndex: "channel_name" },
    { title: "支付状态", scopedSlots: { customRender: "is_pay" } },
    { title: "微信交易单号", dataIndex: "transaction_id" },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadPaymentChannel();
    this.loadData({
      trade_type: 1
    });
  }

  async loadPaymentChannel() {
    const res = await this.$store.dispatch("bill/getPayChannels", {});
    if (res && res.Data) {
      this.paychannels = res.Data;
    }
  }

  async exportExcel() {
    this.$confirm({
      title: "确认信息",
      content: "确认导出吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("finance/exportTradeLogs", {
          trade_type: 1,
          ...this.searchData
        });
        // console.log(res)
        if (res && res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          filesaver.saveAs(blob, `支付记录${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
        }
      }
    });
  }
}
